import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  // Supabase automatski uhvati token iz URL-a kad korisnik klikne link s maila,
  // ali provjeravamo je li sesija uspostavljena za oporavak
  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      if (!data.session) {
        // Ako nema aktivne sesije oporavka, možda je link istekao
        setError("Link za resetiranje lozinke je nevažeći ili je istekao.");
      }
    };
    checkSession();
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError("Lozinke se ne podudaraju.");
      return;
    }

    if (password.length < 6) {
      setError("Lozinka mora imati najmanje 6 znakova.");
      return;
    }

    setLoading(true);

    try {
      const { error: updateError } = await supabase.auth.updateUser({
        password: password,
      });

      if (updateError) throw updateError;

      setSuccess(true);
      setTimeout(() => {
        navigate("/admin-login");
      }, 3000);
    } catch (err) {
      setError(err.message || "Došlo je do pogreške pri promjeni lozinke.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img src={FucaScoreLogo} alt="FucaScore logo" className="logo" />
        <h2>Nova lozinka</h2>

        {!success ? (
          <form onSubmit={handleReset}>
            <div className="input-field">
              <label>Nova lozinka</label>
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  <i
                    className={
                      showPassword ? "fi fi-rs-eye" : "fi fi-rs-crossed-eye"
                    }
                  ></i>
                </span>
              </div>
            </div>

            <div className="input-field">
              <label>Potvrdi novu lozinku</label>
              <div className="password-container">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <span
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  <i
                    className={
                      showConfirmPassword
                        ? "fi fi-rs-eye"
                        : "fi fi-rs-crossed-eye"
                    }
                  ></i>
                </span>
              </div>
            </div>

            {error && <p className="error-msg">{error}</p>}

            <button type="submit" disabled={loading}>
              {loading ? "Spremanje..." : "Spremi novu lozinku"}
            </button>
          </form>
        ) : (
          <div className="success-message-box" style={{ textAlign: "center" }}>
            <p className="success-msg">Lozinka je uspješno promijenjena!</p>
            <p style={{ color: "#8899a6", fontSize: "0.9rem" }}>
              Preusmjeravanje na prijavu...
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
